import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';

class ImageSnippet {
  constructor(public src: string, 
    public file: File,
   
   ) {}   //image uploading
}

@Component({
  selector: 'app-edit-product',
  templateUrl: './edit-product.component.html',
  styleUrls: ['./edit-product.component.css']
})
export class EditProductComponent implements OnInit {

  constructor(private productService:ServiceService,private route: ActivatedRoute, private router: Router) { }
  
  output:any=[]; //---store get() result--------
  productId='';
  //getUrl='http://192.241.151.66:5000/viewProducts';
  //putUrl='http://192.241.151.66:5000/updateProducts';
  //brandUrl='http://192.241.151.66:5000/viewBrands/brand_dropdown'

  selectedFile: ImageSnippet | undefined;   //image uploading
  data:any={}
  alert="";
  brand:any=[];
  isShown: boolean = false;
  brandName:any=[];
  folderName:any=[];
  fileName:any=null;
  ImageName:any=null
  SizeMessage=""
  link="";
  document="";
  isLoader=false;
  close=''
  close1=""
  btnShown=false;
  NewFileName:any;
 //--------function for shown the alert----------
 shown(){
  this.isShown=false
}
//for showing notifivation
notification(){
  this.isShown = !this.isShown;
}
//for getting id of selected brand
onSelected(value:string): void {
  this.data.product_brand_id = value;

  //-------api get()calling for brand name of carrasponding id-------------
  this.productService.BrandDropdownById('/'+value).subscribe((res)=>{
    this.brandName=res.data;
  this.data.product_brand_name=this.brandName[0].brand_name;
  console.log("dept after=",this.data.product_brand_id);
  console.log("dept after=",this.brandName[0].brand_name);
  })
}

//for getting name of selecter shan'app folder name
onSelectedFolder(value:string): void {
  this.data.shansapp_folder = value;
}


  btnClick()
  {
    console.log("link=",this.data.video_link)
    if(this.data.video_link==" ")
    {
      this.data.video_link=this.link;
    }
    if( this.data.technical_document==" " && this.document!=""){
        this.data.technical_document=this.document;
    }
    //--------api for put----------//
    this.productService.UpdateProduct(this.data).subscribe((res) => {
      console.log("Pname=",this.data.P_name);
      this.alert=res.message;
      console.log("res=",this.alert);

    })
}
//--------function for upload video---------------
ProcessVideoFile(imageInput:any){
  this.SizeMessage=""
 
  const file: File = imageInput.files[0];
    const reader = new FileReader();
    reader.addEventListener('load', (event: any) => {  
      this.selectedFile = new ImageSnippet(event.target.result, file);
      
      this.ImageName=this.selectedFile.file.name

      console.log("selected file=",this.selectedFile.file);
      this.fileName=this.selectedFile.file
      //---------------------------------------------------------------------------
       this.NewFileName=this.output[0].product_name.replace(/ /g, "_");
       this.NewFileName = this.NewFileName.substring(0,this.NewFileName.length - 1);
       //this.NewFileName= this.NewFileName.
       var fileExtension = '.' + this.fileName.name.split('.').pop();
       this.NewFileName=this.NewFileName+fileExtension;
       console.log("extention=",this.NewFileName)
     // this.fileName.name = Math.random().toString(36).substring(7) + new Date().getTime() + fileExtension;

      //----------------------------------------------------------------------------
      

      const formDatas = new FormData();
      formDatas.append('file',this.fileName,this.NewFileName);
      var size:number=+((this.fileName.size)/ 1048576).toFixed(2)
      if(size>4){
        this.SizeMessage="only 4 MB allow"
        console.log(this.SizeMessage)
        this.fileName="";
        return;
      }
      
      console.log("size=",size);
      this.isLoader=true;
this.productService.FileUopload(formDatas).subscribe((res)=>{
  //this.output=res.data
  if(res.sucess){
    this.isLoader=false;
  }
  console.log("res=",res.sucess)
  console.log("url=",res.data);
  this.data.technical_document=res.data;
  this.document=res.data;
  this.btnShown=true;
  this.close1="X";
})

   });
 
reader.readAsDataURL(file);
//------Api call for upload file-------------

console.log("upload video")
}
goToLink(link:any){
  window.open(link);
}
//-----function for change video link---------
ChangeVideo(value:any){
  console.log("hai");
  if(this.data.video_link!=" "){
    this.link=" "
    this.close=" "
  }
}
Close(){
this.close=""
this.link=" "
this.data.video_link=" "
}
Close1(){
  this.close1=""
  this.document=""
  this.data.technical_document=" "
  this.btnShown=false;
}
//---------function for copy message------------------------
copyMessage(val: string){
  const selBox = document.createElement('textarea');
  selBox.style.position = 'fixed';
  selBox.style.left = '0';
  selBox.style.top = '0';
  selBox.style.opacity = '0';
  selBox.value = val;
  document.body.appendChild(selBox);
  selBox.focus();
  selBox.select();
  document.execCommand('copy');
  document.body.removeChild(selBox);
}
  ngOnInit(): void {

     //---call function in service for employee Id------
     this.productId=this.productService.getProductId()
     console.log("product id=",this.productId)

    //-------api get()calling-------------
    this.productService.ViewProducts('/'+this.productId).subscribe((res)=>{
      this.output=res.data
      console.log("name=",this.output[0].product_id)
      this.link=this.output[0].video_link;
      if(this.link!=" ")
      {
        this.close="X"
      }
      this.document=this.output[0].technical_document;
      if(this.document!="")
      {
        this.close1="X"
        this.btnShown=true;
      }

      this.data={
        product_id:this.output[0].product_id,
        product_code:this.output[0].product_code,
        product_name:this.output[0].product_name,
        product_full_description:this.output[0].product_full_description,
        product_sku:this.output[0].product_sku,
        product_brand_id:this.output[0].product_brand_id,
        product_brand_name:this.output[0].product_brand_name,
        product_category_id:this.output[0].product_category_id,
        product_category_name:this.output[0].product_category_name,
        shansapp_folder:this.output[0].shansapp_folder,
        rf_id_code:this.output[0].rf_id_code,
        deviation:this.output[0].deviation,

        technical_document:" ",
        video_link:" ",

        folder:this.output[0].folder,
        stock:this.output[0].stock,
       // supplier_price:this.output[0].supplier_price,
       // abudhabi_std_price:this.output[0].abudhabi_std_price,
     //   accounting_price:this.output[0].accounting_price,
      //  al_ain_std_price:this.output[0].al_ain_std_price,

      //  al_quiz_std_price:this.output[0].al_quiz_std_price,
     //   aweer_std_price:this.output[0].aweer_std_price,
     //   dip_std_price:this.output[0].dip_std_price,
     //   qusais_std_price:this.output[0].qusais_std_price,
    //    rak_std_price:this.output[0].rak_std_price,
    //    sajaa_std_price:this.output[0].sajaa_std_price,
    //    shj_std_price:this.output[0].shj_std_price,
    //    product_uom_main:this.output[0].product_uom_main
     }
     
    if(this.output[0].tempPrices.length!=0){
      
      for(var i=0;i<this.output[0].tempPrices.length;i++){

       //console.log(this.output[0].tempPrices[i].price_type_name)
       if(this.output[0].tempPrices[i].price_type_name=='RAK STD PRICE'){

        this.data.rak_std_price=this.output[0].tempPrices[i].price;

       }
       else if(this.output[0].tempPrices[i].price_type_name=='AWEER STD PRICE')
       {

        this.data.aweer_std_price=this.output[0].tempPrices[i].price;
        
       }
       else if(this.output[0].tempPrices[i].price_type_name=='DIP STD PRICE')
       {

        this.data.dip_std_price=this.output[0].tempPrices[i].price;
        
       }
       else if(this.output[0].tempPrices[i].price_type_name=='ABU DHABI STD PRICE')
       {

        this.data.abudhabi_std_price=this.output[0].tempPrices[i].price;
        
       }
       else if(this.output[0].tempPrices[i].price_type_name=='QUSAIS STD PRICE')
       {

        this.data.qusais_std_price=this.output[0].tempPrices[i].price;
        
       }
       else if(this.output[0].tempPrices[i].price_type_name=='SHJ STD PRICE')
       {

        this.data.shj_std_price=this.output[0].tempPrices[i].price;
        
       }
       else if(this.output[0].tempPrices[i].price_type_name=='AL QUOZ STD PRICE')
       {

        this.data.al_quiz_std_price=this.output[0].tempPrices[i].price;
        
       }
       else if(this.output[0].tempPrices[i].price_type_name=='AL AIN STD PRICE')
       {

        this.data.al_ain_std_price=this.output[0].tempPrices[i].price;
        
       }
       else if(this.output[0].tempPrices[i].price_type_name=='ACCOUNTING PRICE')
       {

        this.data.accounting_price=this.output[0].tempPrices[i].price;
        
       }
       else if(this.output[0].tempPrices[i].price_type_name=='SAJAA STD PRICE')
       {

        this.data.sajaa_std_price=this.output[0].tempPrices[i].price;
        
       }
       else if(this.output[0].tempPrices[i].price_type_name=='PRICE LEVEL 1')
       {

        this.data.price_level_1=this.output[0].tempPrices[i].price;
        
       }
       else if(this.output[0].tempPrices[i].price_type_name=='TEST')
       {

        this.data.test=this.output[0].tempPrices[i].price;
        
       }

        
      } //end for
      
    }//end if


  //------------------------------------------------------------  
    })

     //-------api for get brand name---------

   this.productService.BrandDropdown().subscribe((res)=>{
    this.brand=res.data
   })
 
  //-------api for get brand name---------

      this.productService.BrandDropdown().subscribe((res)=>{
        this.brandName=res.data
       // console.log("brand=",this.brandName)
  
      })
  //-----api for get folder name-----------------
  this.productService.FolderDropdown().subscribe((res)=>{
    this.folderName=res.data
    console.log("folder=",this.folderName)
  })
  }

}
